// extracted by mini-css-extract-plugin
module.exports = {"btn":"AppButton_btn__1TL98"};